/**
 * SacFilterType
 * @author Thacryba
 */

export enum SacAgcoFilterType {
  NF = 1,
  CORREIO = 3,
  PEDIDO = 4,
  DOC = 5,
}
